<template>
  <div>
    <div v-if="error" class="alert alert-danger">
      {{error}}
    </div>
    <b-form @submit.prevent="onSubmit">

      <b-form-group id="ig2" label-for="paramValue" label="Единица измерения">
        <b-form-input id="paramValue" type="text" required placeholder="Введите значение" v-model="mu.text" autocomplete="off"></b-form-input>
      </b-form-group>

      <b-button type="submit" class="btn-info" variant="primary">Сохранить</b-button>

    </b-form>
  </div>
</template>

<script>
import {host} from "@/constants";

export default {
  name: "MeasurementUnitEdit",
  props: {
    currentMeasurementUnit: Object
  },
  data() {
    return {
      error: null,
      mu: {
        value: this.currentMeasurementUnit !== null ? this.currentMeasurementUnit.value : null,
        text: this.currentMeasurementUnit !== null ? this.currentMeasurementUnit.text : null
      }
    }
  },
  methods: {
    onSubmit() {
      let method = 'POST'
      if (this.currentMeasurementUnit !== null) {
        method = 'PUT'
      }


      fetch(host + '/rest/dicts/measurementunit', {
        method: method,
        credentials: 'include',
        body: JSON.stringify(this.mu),
        headers: {'Content-Type': 'application/json; charset=utf-8'}
      }).then(response => response.json())
          .then(json => {
            if (json.resultCode == 0) {

              this.$emit('save-success')
            } else {

              this.error = json.resultCode + ' ' + json.message;
            }
          })
          .catch(error => {
            this.error = error

          })

    }
  }
}
</script>

<style scoped>

</style>